import mixpanel from "mixpanel-browser";

export const getId = () => {
  try {
    let id = localStorage.getItem("unique_id_mixpanel");
    return id;
  } catch (error) {
    return "";
  }
  return "";
};

export default mixpanel;
